import React from 'react';
import { NavLink } from 'react-router-dom';
import SectionNav, { SECTIONS, ProTag, useSectionLocked } from './SectionNav';
import PlanSwitcher from './PlanSwitcher';

export default function PlanningHubSidebar() {
  const isLocked = useSectionLocked();
  return (
    <aside className="lg:w-56 xl:w-64 lg:flex-shrink-0 bg-surface-primary border-b lg:border-b-0 lg:border-r border-surface-border">
      <div className="lg:hidden px-3 pt-2">
        <PlanSwitcher />
      </div>
      {/* Phones and tablets: a strip of steps that shows where you are. */}
      <nav className="lg:hidden relative flex gap-2 overflow-x-auto px-3 py-2" aria-label="Financial planning steps">
        {SECTIONS.map((section) => (
          <NavLink
            key={section.path}
            to={section.path}
            className={({ isActive }) =>
              `flex-shrink-0 flex items-center gap-2 px-3 min-h-[44px] rounded-lg text-xs font-mono uppercase tracking-wider border ${
                isActive
                  ? 'bg-terminal-dark-green/20 text-terminal-green border-terminal-dark-green'
                  : 'text-txt-secondary border-surface-border'
              }`
            }
          >
            <span>{section.icon}</span>
            <span>{section.short}</span>
            {isLocked(section) && <ProTag />}
          </NavLink>
        ))}
      </nav>

      {/* Desktop nav */}
      <div className="hidden lg:block sticky top-0 p-4">
        <h2 className="font-display font-bold text-terminal-green crt-glow uppercase tracking-wider text-xs mb-4 px-3">
          Financial Planning
        </h2>
        <PlanSwitcher className="mb-4" />
        <SectionNav />
      </div>
    </aside>
  );
}
